import { createAsyncThunk } from '@reduxjs/toolkit';
import {  _mediaServiceUrls } from '@custom/Utils/constants/apiUrls';
import { getCloudPACSToken } from '@custom/Utils/authUtils';

const createIsoImage = createAsyncThunk('createIso', async (value:any,{rejectWithValue}) => {

  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  try {
    const pacs_token = getCloudPACSToken();
    let response = await fetch(_mediaServiceUrls.createIso, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Pacs-Token': pacs_token,
      },
      body : JSON.stringify(value)
    })
    if(response.status >= 200){
    // return await response.json()
    const blob = await response.blob(); // Convert buffer to blob

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    // Specify the file name (optional)
    a.download = 'filename.iso';

    // Trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);

    }
    else{
      rejectWithValue('Failed to fetch')
    }
  } catch (error) {
    return error;
  }
});

export default createIsoImage;
